// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// eslint-disable-next-line
const firebaseApp = initializeApp({
  apiKey: "AIzaSyCFadtGfkOns3MP3DrUvyYRImum7XWLWcc",
  authDomain: "areeb-on.firebaseapp.com",
  projectId: "areeb-on",
  storageBucket: "areeb-on.appspot.com",
  messagingSenderId: "1034951997744",
  appId: "1:1034951997744:web:57bbae857b1517233db0f5",
  measurementId: "G-P6SV84GGSM"
});

const db = getFirestore();

export { db };